
export default {
  data: () => ({
    model: null,

    unsavedDialogOpen: false,
    navIntentTo: null,
    renderKey: 0,
    justSaved: false,
  }),
  props: {
    modelType: null,
    layoutId: {
      type: String,
    },
    id: null,
    fluid: true,
    hideFooter: false,
  },
  methods: {
    guardUnsavedChanges(to, from, next) {
      if (
        !this.model ||
        // A never-saved model reports hasUnsavedChanges true from
        // construction alone (confirmed live: SubmissionPaymentSelector's
        // apply-credit success reload stays on /submissions/new?... --
        // `id === "new"` never becomes a real id -- so setupModelFromId
        // reconstructs a brand-new throwaway model from $route.query on
        // that reload, and it reads as dirty with zero fields ever touched).
        // There is no server-side state to lose for a model that was never
        // persisted in the first place.
        this.model.isNew ||
        // `justSaved` (component-local, set by onSave() below), NOT
        // `model.wasJustSaved` -- confirmed live: CrudModel.wasJustSaved is
        // a 1-second window since the model's last markAsSaved(), and
        // hydrate() calls markAsSaved() on every plain GET to establish the
        // clean baseline, not just on an explicit user save. Reading it
        // here let any edit made within a second of the page simply
        // LOADING bypass the guard entirely -- a real edit, silently
        // unprotected. justSaved is only ever true immediately after this
        // component's own onSave() runs, right before the resulting
        // navigateAfterSave() navigation.
        this.justSaved ||
        !this.model.hasUnsavedChanges ||
        this.navIntentTo
      )
        return next();

      this.navIntentTo = to;
      this.unsavedDialogOpen = true;
    },
    onSave() {
      this.justSaved = true;
      this.layout.navigateAfterSave();
    },
    onDelete() {
      this.layout.navigateAfterDelete();
    },
    onRevert() {
      this.model.reset();
      this.renderKey++;
    },
    confirmNav() {
      this.unsavedDialogOpen = false;
      this.$router.push(this.navIntentTo);
    },
    cancelNav() {
      this.navIntentTo = null;
      this.unsavedDialogOpen = false;
    },
    setupModelFromId(id) {
      if (id == "new") {
        const newModelOpts = this.$route.query;
        this.model = this.layout.newModel(newModelOpts);
        return;
      }

      this.layout.getModel(id).then((model) => {
        this.model = model;
      });
    },
  },
  computed: {
    title() {
      return this.model.label;
    },
    layout() {
      if (this.model) {
        return this.model.getModelLayout(this.layoutId);
      }
      return this.modelType.getModelLayout(this.layoutId);
    },
    showActions() {
      return (
        !this.hideFooter &&
        this.model &&
        !this.model.isReadonlyToUser() &&
        (this.model.getEditableFields().length > 0 ||
          this.layout.footerComponents.length > 0)
      );
    },
  },
  watch: {
    model(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.renderKey++;
      }
    },
    "$route.params.id": {
      async handler() {
        if (this.id) return;

        this.setupModelFromId(this.$route.params.id);
      },
      immediate: true,
    },
    id: {
      async handler() {
        if (!this.id) return;

        this.setupModelFromId(this.id);
      },
      immediate: true,
    },
  },
  // Vue-router only ever invokes an in-component `beforeRouteLeave` on a
  // route's OWN matched component -- Single.vue is always a nested child of
  // a `pages/*.vue` file, never the routed component itself, so this hook is
  // never actually called by a real in-app navigation. Kept as a harmless
  // no-op fallback for the rare case this ever IS the routed component;
  // `created()`/`beforeDestroy()` below self-register the same guard as a
  // global `router.beforeEach`, vue-router's own documented workaround for
  // guarding navigation from a non-route component.
  beforeRouteLeave(to, from, next) {
    this.guardUnsavedChanges(to, from, next);
  },
  created() {
    this.unregisterUnsavedChangesGuard = this.$router.beforeEach(
      (to, from, next) => this.guardUnsavedChanges(to, from, next)
    );
  },
  beforeDestroy() {
    if (this.unregisterUnsavedChangesGuard) {
      this.unregisterUnsavedChangesGuard();
    }
  },
};
